// extracted by mini-css-extract-plugin
export var csatScore = "_nb-5";
export var header = "_nb-1";
export var panelWrapper = "_nb-2";
export var postPreview = "_nb-3";
export var rightContent = "_nb-0";
export var wrappingText = "_nb-4";